import { jsx as d } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import i from "@mui/material/Paper";
import l from "styled-components";
import { getShadow as m } from "../../theme/utils/styleUtils.js";
const n = {
  root: "paperRoot",
  component: "paperComponent"
}, f = l(i).withConfig({
  displayName: "StyledPaper"
})([
  "&&.paperRoot{padding:16px;box-shadow:",
  ";border:",
  ";border-color:",
  ";}"
], ({ variant: o, theme: r }) => m(r, o), ({ variant: o }) => o === "outlined" ? "1px solid" : "0px solid", ({ theme: o }) => o.primaryBorder), c = /* @__PURE__ */ s(({ children: o, classes: r, square: e = !1, variant: p = "elevation", ...a }, t) => /* @__PURE__ */ d(f, {
  ...a,
  ref: t,
  classes: {
    ...n,
    ...r
  },
  square: e,
  variant: p,
  children: o
}));
c.displayName = "Paper";
export {
  c as default
};
